export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.job.GetLoadJobTargetTableColumns.AmbiguousColumnReference';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.job.GetLoadJobTargetTableColumns.CannotCastValueOfType';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.job.GetLoadJobTargetTableColumns.ClientConnectionError';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_DATA_LOADING_FAILED =
    'europa.job.GetLoadJobTargetTableColumns.DataLoadingFailed';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.GetLoadJobTargetTableColumns.DatabaseNotExistsOrNotAuthorized';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.job.GetLoadJobTargetTableColumns.InsufficientPrivileges';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.job.GetLoadJobTargetTableColumns.InsufficientTaskPrivileges';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.job.GetLoadJobTargetTableColumns.InvalidAccessToken';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.job.GetLoadJobTargetTableColumns.InvalidAccountName';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_INVALID_IDENTIFIER =
    'europa.job.GetLoadJobTargetTableColumns.InvalidIdentifier';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.job.GetLoadJobTargetTableColumns.InvalidParameterTypeForFunction';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.job.GetLoadJobTargetTableColumns.MaxFileSizeExceeded';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_MISSING_COLUMN =
    'europa.job.GetLoadJobTargetTableColumns.MissingColumn';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.job.GetLoadJobTargetTableColumns.NoActiveWarehouseSelected';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.job.GetLoadJobTargetTableColumns.NotAuthenticatedToSnowflake';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.GetLoadJobTargetTableColumns.NotExistsOrNotAuthorized';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.job.GetLoadJobTargetTableColumns.NotExistsOrOperationCannotBePerformed';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.job.GetLoadJobTargetTableColumns.ObjectAlreadyExists';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.GetLoadJobTargetTableColumns.SchemaNotExistsOrNotAuthorized';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.job.GetLoadJobTargetTableColumns.SnowflakeInternalServerError';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.job.GetLoadJobTargetTableColumns.SnowflakeNotConfigured';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.job.GetLoadJobTargetTableColumns.SnowflakeQueryCanceled';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_SUCCESS_TARGET_TABLE_COLUMNS =
    'europa.job.GetLoadJobTargetTableColumns.TargetTableColumns';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_TARGET_TABLE_NOT_EXISTS =
    'europa.job.GetLoadJobTargetTableColumns.TargetTableNotExists';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_TIMEOUT =
    'europa.job.GetLoadJobTargetTableColumns.Timeout';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.job.GetLoadJobTargetTableColumns.UncategorizedSqlError';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.GetLoadJobTargetTableColumns.UnexpectedFailure';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_UNKNOWN_FUNCTION =
    'europa.job.GetLoadJobTargetTableColumns.UnknownFunction';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.job.GetLoadJobTargetTableColumns.UnknownFunctions';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.job.GetLoadJobTargetTableColumns.UserDiffersFromToken';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.job.GetLoadJobTargetTableColumns.ValueNotRecognized';
export const GET_LOAD_JOB_TARGET_TABLE_COLUMNS_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.job.GetLoadJobTargetTableColumns.WarehouseSuspended';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.job.GetSnowflakeStageDetails.AmbiguousColumnReference';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.job.GetSnowflakeStageDetails.CannotCastValueOfType';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.job.GetSnowflakeStageDetails.ClientConnectionError';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_DATA_LOADING_FAILED =
    'europa.job.GetSnowflakeStageDetails.DataLoadingFailed';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.GetSnowflakeStageDetails.DatabaseNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.job.GetSnowflakeStageDetails.InsufficientPrivileges';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.job.GetSnowflakeStageDetails.InsufficientTaskPrivileges';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.job.GetSnowflakeStageDetails.InvalidAccessToken';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.job.GetSnowflakeStageDetails.InvalidAccountName';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_INVALID_IDENTIFIER =
    'europa.job.GetSnowflakeStageDetails.InvalidIdentifier';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.job.GetSnowflakeStageDetails.InvalidParameterTypeForFunction';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.job.GetSnowflakeStageDetails.MaxFileSizeExceeded';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_MISSING_COLUMN =
    'europa.job.GetSnowflakeStageDetails.MissingColumn';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.job.GetSnowflakeStageDetails.NoActiveWarehouseSelected';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.job.GetSnowflakeStageDetails.NotAuthenticatedToSnowflake';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.GetSnowflakeStageDetails.NotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.job.GetSnowflakeStageDetails.NotExistsOrOperationCannotBePerformed';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.job.GetSnowflakeStageDetails.ObjectAlreadyExists';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.GetSnowflakeStageDetails.SchemaNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.job.GetSnowflakeStageDetails.SnowflakeInternalServerError';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.job.GetSnowflakeStageDetails.SnowflakeNotConfigured';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.job.GetSnowflakeStageDetails.SnowflakeQueryCanceled';
export const GET_SNOWFLAKE_STAGE_DETAILS_SUCCESS_STAGE_DETAILS =
    'europa.job.GetSnowflakeStageDetails.StageDetails';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_TIMEOUT =
    'europa.job.GetSnowflakeStageDetails.Timeout';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.job.GetSnowflakeStageDetails.UncategorizedSqlError';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.GetSnowflakeStageDetails.UnexpectedFailure';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_UNKNOWN_FUNCTION =
    'europa.job.GetSnowflakeStageDetails.UnknownFunction';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.job.GetSnowflakeStageDetails.UnknownFunctions';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.job.GetSnowflakeStageDetails.UserDiffersFromToken';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.job.GetSnowflakeStageDetails.ValueNotRecognized';
export const GET_SNOWFLAKE_STAGE_DETAILS_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.job.GetSnowflakeStageDetails.WarehouseSuspended';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.job.GetSnowflakeStageFileFormatDetails.AmbiguousColumnReference';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.job.GetSnowflakeStageFileFormatDetails.CannotCastValueOfType';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.job.GetSnowflakeStageFileFormatDetails.ClientConnectionError';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_DATA_LOADING_FAILED =
    'europa.job.GetSnowflakeStageFileFormatDetails.DataLoadingFailed';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.GetSnowflakeStageFileFormatDetails.DatabaseNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_SUCCESS_FILE_FORMAT_DETAILS =
    'europa.job.GetSnowflakeStageFileFormatDetails.FileFormatDetails';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.job.GetSnowflakeStageFileFormatDetails.InsufficientPrivileges';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.job.GetSnowflakeStageFileFormatDetails.InsufficientTaskPrivileges';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.job.GetSnowflakeStageFileFormatDetails.InvalidAccessToken';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.job.GetSnowflakeStageFileFormatDetails.InvalidAccountName';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_INVALID_IDENTIFIER =
    'europa.job.GetSnowflakeStageFileFormatDetails.InvalidIdentifier';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.job.GetSnowflakeStageFileFormatDetails.InvalidParameterTypeForFunction';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.job.GetSnowflakeStageFileFormatDetails.MaxFileSizeExceeded';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_MISSING_COLUMN =
    'europa.job.GetSnowflakeStageFileFormatDetails.MissingColumn';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.job.GetSnowflakeStageFileFormatDetails.NoActiveWarehouseSelected';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.job.GetSnowflakeStageFileFormatDetails.NotAuthenticatedToSnowflake';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.GetSnowflakeStageFileFormatDetails.NotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.job.GetSnowflakeStageFileFormatDetails.NotExistsOrOperationCannotBePerformed';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.job.GetSnowflakeStageFileFormatDetails.ObjectAlreadyExists';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.GetSnowflakeStageFileFormatDetails.SchemaNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.job.GetSnowflakeStageFileFormatDetails.SnowflakeInternalServerError';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.job.GetSnowflakeStageFileFormatDetails.SnowflakeNotConfigured';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.job.GetSnowflakeStageFileFormatDetails.SnowflakeQueryCanceled';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_TIMEOUT =
    'europa.job.GetSnowflakeStageFileFormatDetails.Timeout';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.job.GetSnowflakeStageFileFormatDetails.UncategorizedSqlError';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.GetSnowflakeStageFileFormatDetails.UnexpectedFailure';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_UNKNOWN_FUNCTION =
    'europa.job.GetSnowflakeStageFileFormatDetails.UnknownFunction';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.job.GetSnowflakeStageFileFormatDetails.UnknownFunctions';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.job.GetSnowflakeStageFileFormatDetails.UserDiffersFromToken';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.job.GetSnowflakeStageFileFormatDetails.ValueNotRecognized';
export const GET_SNOWFLAKE_STAGE_FILE_FORMAT_DETAILS_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.job.GetSnowflakeStageFileFormatDetails.WarehouseSuspended';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.job.GetSnowflakeStageFileInfo.AmbiguousColumnReference';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.job.GetSnowflakeStageFileInfo.CannotCastValueOfType';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.job.GetSnowflakeStageFileInfo.ClientConnectionError';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_DATA_LOADING_FAILED =
    'europa.job.GetSnowflakeStageFileInfo.DataLoadingFailed';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.GetSnowflakeStageFileInfo.DatabaseNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_FILE_FORMAT_NOT_SUPPORTED =
    'europa.job.GetSnowflakeStageFileInfo.FileFormatNotSupported';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.job.GetSnowflakeStageFileInfo.InsufficientPrivileges';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.job.GetSnowflakeStageFileInfo.InsufficientTaskPrivileges';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.job.GetSnowflakeStageFileInfo.InvalidAccessToken';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.job.GetSnowflakeStageFileInfo.InvalidAccountName';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_INVALID_IDENTIFIER =
    'europa.job.GetSnowflakeStageFileInfo.InvalidIdentifier';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.job.GetSnowflakeStageFileInfo.InvalidParameterTypeForFunction';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.job.GetSnowflakeStageFileInfo.MaxFileSizeExceeded';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_MISSING_COLUMN =
    'europa.job.GetSnowflakeStageFileInfo.MissingColumn';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.job.GetSnowflakeStageFileInfo.NoActiveWarehouseSelected';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_NO_SAMPLE_FILES_FOUND_BY_PATTERN =
    'europa.job.GetSnowflakeStageFileInfo.NoSampleFilesFoundByPattern';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.job.GetSnowflakeStageFileInfo.NotAuthenticatedToSnowflake';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.GetSnowflakeStageFileInfo.NotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.job.GetSnowflakeStageFileInfo.NotExistsOrOperationCannotBePerformed';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.job.GetSnowflakeStageFileInfo.ObjectAlreadyExists';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.GetSnowflakeStageFileInfo.SchemaNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.job.GetSnowflakeStageFileInfo.SnowflakeInternalServerError';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.job.GetSnowflakeStageFileInfo.SnowflakeNotConfigured';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.job.GetSnowflakeStageFileInfo.SnowflakeQueryCanceled';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_SUCCESS_SNOWFLAKE_STAGE_FILE_INFO =
    'europa.job.GetSnowflakeStageFileInfo.SnowflakeStageFileInfo';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_TIMEOUT =
    'europa.job.GetSnowflakeStageFileInfo.Timeout';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.job.GetSnowflakeStageFileInfo.UncategorizedSqlError';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.GetSnowflakeStageFileInfo.UnexpectedFailure';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_UNKNOWN_FUNCTION =
    'europa.job.GetSnowflakeStageFileInfo.UnknownFunction';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.job.GetSnowflakeStageFileInfo.UnknownFunctions';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.job.GetSnowflakeStageFileInfo.UserDiffersFromToken';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.job.GetSnowflakeStageFileInfo.ValueNotRecognized';
export const GET_SNOWFLAKE_STAGE_FILE_INFO_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.job.GetSnowflakeStageFileInfo.WarehouseSuspended';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.job.ListSnowflakeFileFormats.AmbiguousColumnReference';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.job.ListSnowflakeFileFormats.CannotCastValueOfType';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.job.ListSnowflakeFileFormats.ClientConnectionError';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_DATA_LOADING_FAILED =
    'europa.job.ListSnowflakeFileFormats.DataLoadingFailed';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.ListSnowflakeFileFormats.DatabaseNotExistsOrNotAuthorized';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.job.ListSnowflakeFileFormats.InsufficientPrivileges';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.job.ListSnowflakeFileFormats.InsufficientTaskPrivileges';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.job.ListSnowflakeFileFormats.InvalidAccessToken';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.job.ListSnowflakeFileFormats.InvalidAccountName';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_INVALID_IDENTIFIER =
    'europa.job.ListSnowflakeFileFormats.InvalidIdentifier';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.job.ListSnowflakeFileFormats.InvalidParameterTypeForFunction';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.job.ListSnowflakeFileFormats.MaxFileSizeExceeded';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_MISSING_COLUMN =
    'europa.job.ListSnowflakeFileFormats.MissingColumn';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.job.ListSnowflakeFileFormats.NoActiveWarehouseSelected';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.job.ListSnowflakeFileFormats.NotAuthenticatedToSnowflake';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.ListSnowflakeFileFormats.NotExistsOrNotAuthorized';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.job.ListSnowflakeFileFormats.NotExistsOrOperationCannotBePerformed';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.job.ListSnowflakeFileFormats.ObjectAlreadyExists';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.ListSnowflakeFileFormats.SchemaNotExistsOrNotAuthorized';
export const LIST_SNOWFLAKE_FILE_FORMATS_SUCCESS_SNOWFLAKE_FILE_FORMATS =
    'europa.job.ListSnowflakeFileFormats.SnowflakeFileFormats';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.job.ListSnowflakeFileFormats.SnowflakeInternalServerError';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.job.ListSnowflakeFileFormats.SnowflakeNotConfigured';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.job.ListSnowflakeFileFormats.SnowflakeQueryCanceled';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_TIMEOUT =
    'europa.job.ListSnowflakeFileFormats.Timeout';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.job.ListSnowflakeFileFormats.UncategorizedSqlError';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.ListSnowflakeFileFormats.UnexpectedFailure';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_UNKNOWN_FUNCTION =
    'europa.job.ListSnowflakeFileFormats.UnknownFunction';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.job.ListSnowflakeFileFormats.UnknownFunctions';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.job.ListSnowflakeFileFormats.UserDiffersFromToken';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.job.ListSnowflakeFileFormats.ValueNotRecognized';
export const LIST_SNOWFLAKE_FILE_FORMATS_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.job.ListSnowflakeFileFormats.WarehouseSuspended';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.job.ListSnowflakeStageFiles.AmbiguousColumnReference';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.job.ListSnowflakeStageFiles.CannotCastValueOfType';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.job.ListSnowflakeStageFiles.ClientConnectionError';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_DATA_LOADING_FAILED =
    'europa.job.ListSnowflakeStageFiles.DataLoadingFailed';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.ListSnowflakeStageFiles.DatabaseNotExistsOrNotAuthorized';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.job.ListSnowflakeStageFiles.InsufficientPrivileges';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.job.ListSnowflakeStageFiles.InsufficientTaskPrivileges';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.job.ListSnowflakeStageFiles.InvalidAccessToken';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.job.ListSnowflakeStageFiles.InvalidAccountName';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_INVALID_IDENTIFIER =
    'europa.job.ListSnowflakeStageFiles.InvalidIdentifier';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.job.ListSnowflakeStageFiles.InvalidParameterTypeForFunction';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.job.ListSnowflakeStageFiles.MaxFileSizeExceeded';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_MISSING_COLUMN =
    'europa.job.ListSnowflakeStageFiles.MissingColumn';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.job.ListSnowflakeStageFiles.NoActiveWarehouseSelected';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.job.ListSnowflakeStageFiles.NotAuthenticatedToSnowflake';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.ListSnowflakeStageFiles.NotExistsOrNotAuthorized';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.job.ListSnowflakeStageFiles.NotExistsOrOperationCannotBePerformed';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.job.ListSnowflakeStageFiles.ObjectAlreadyExists';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.ListSnowflakeStageFiles.SchemaNotExistsOrNotAuthorized';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.job.ListSnowflakeStageFiles.SnowflakeInternalServerError';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.job.ListSnowflakeStageFiles.SnowflakeNotConfigured';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.job.ListSnowflakeStageFiles.SnowflakeQueryCanceled';
export const LIST_SNOWFLAKE_STAGE_FILES_SUCCESS_STAGE_FILES =
    'europa.job.ListSnowflakeStageFiles.StageFiles';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_TIMEOUT =
    'europa.job.ListSnowflakeStageFiles.Timeout';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.job.ListSnowflakeStageFiles.UncategorizedSqlError';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.ListSnowflakeStageFiles.UnexpectedFailure';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_UNKNOWN_FUNCTION =
    'europa.job.ListSnowflakeStageFiles.UnknownFunction';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.job.ListSnowflakeStageFiles.UnknownFunctions';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.job.ListSnowflakeStageFiles.UserDiffersFromToken';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.job.ListSnowflakeStageFiles.ValueNotRecognized';
export const LIST_SNOWFLAKE_STAGE_FILES_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.job.ListSnowflakeStageFiles.WarehouseSuspended';
export const LIST_SNOWFLAKE_STAGES_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.job.ListSnowflakeStages.AmbiguousColumnReference';
export const LIST_SNOWFLAKE_STAGES_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.job.ListSnowflakeStages.CannotCastValueOfType';
export const LIST_SNOWFLAKE_STAGES_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.job.ListSnowflakeStages.ClientConnectionError';
export const LIST_SNOWFLAKE_STAGES_FAILURE_DATA_LOADING_FAILED =
    'europa.job.ListSnowflakeStages.DataLoadingFailed';
export const LIST_SNOWFLAKE_STAGES_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.ListSnowflakeStages.DatabaseNotExistsOrNotAuthorized';
export const LIST_SNOWFLAKE_STAGES_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.job.ListSnowflakeStages.InsufficientPrivileges';
export const LIST_SNOWFLAKE_STAGES_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.job.ListSnowflakeStages.InsufficientTaskPrivileges';
export const LIST_SNOWFLAKE_STAGES_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.job.ListSnowflakeStages.InvalidAccessToken';
export const LIST_SNOWFLAKE_STAGES_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.job.ListSnowflakeStages.InvalidAccountName';
export const LIST_SNOWFLAKE_STAGES_FAILURE_INVALID_IDENTIFIER =
    'europa.job.ListSnowflakeStages.InvalidIdentifier';
export const LIST_SNOWFLAKE_STAGES_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.job.ListSnowflakeStages.InvalidParameterTypeForFunction';
export const LIST_SNOWFLAKE_STAGES_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.job.ListSnowflakeStages.MaxFileSizeExceeded';
export const LIST_SNOWFLAKE_STAGES_FAILURE_MISSING_COLUMN =
    'europa.job.ListSnowflakeStages.MissingColumn';
export const LIST_SNOWFLAKE_STAGES_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.job.ListSnowflakeStages.NoActiveWarehouseSelected';
export const LIST_SNOWFLAKE_STAGES_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.job.ListSnowflakeStages.NotAuthenticatedToSnowflake';
export const LIST_SNOWFLAKE_STAGES_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.ListSnowflakeStages.NotExistsOrNotAuthorized';
export const LIST_SNOWFLAKE_STAGES_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.job.ListSnowflakeStages.NotExistsOrOperationCannotBePerformed';
export const LIST_SNOWFLAKE_STAGES_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.job.ListSnowflakeStages.ObjectAlreadyExists';
export const LIST_SNOWFLAKE_STAGES_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.ListSnowflakeStages.SchemaNotExistsOrNotAuthorized';
export const LIST_SNOWFLAKE_STAGES_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.job.ListSnowflakeStages.SnowflakeInternalServerError';
export const LIST_SNOWFLAKE_STAGES_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.job.ListSnowflakeStages.SnowflakeNotConfigured';
export const LIST_SNOWFLAKE_STAGES_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.job.ListSnowflakeStages.SnowflakeQueryCanceled';
export const LIST_SNOWFLAKE_STAGES_SUCCESS_SNOWFLAKE_STAGES =
    'europa.job.ListSnowflakeStages.SnowflakeStages';
export const LIST_SNOWFLAKE_STAGES_FAILURE_TIMEOUT = 'europa.job.ListSnowflakeStages.Timeout';
export const LIST_SNOWFLAKE_STAGES_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.job.ListSnowflakeStages.UncategorizedSqlError';
export const LIST_SNOWFLAKE_STAGES_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.ListSnowflakeStages.UnexpectedFailure';
export const LIST_SNOWFLAKE_STAGES_FAILURE_UNKNOWN_FUNCTION =
    'europa.job.ListSnowflakeStages.UnknownFunction';
export const LIST_SNOWFLAKE_STAGES_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.job.ListSnowflakeStages.UnknownFunctions';
export const LIST_SNOWFLAKE_STAGES_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.job.ListSnowflakeStages.UserDiffersFromToken';
export const LIST_SNOWFLAKE_STAGES_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.job.ListSnowflakeStages.ValueNotRecognized';
export const LIST_SNOWFLAKE_STAGES_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.job.ListSnowflakeStages.WarehouseSuspended';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.job.LoadSnowflakeTable.AmbiguousColumnReference';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_CANCELED = 'europa.job.LoadSnowflakeTable.Canceled';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.job.LoadSnowflakeTable.CannotCastValueOfType';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.job.LoadSnowflakeTable.ClientConnectionError';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_DATA_LOADING_FAILED =
    'europa.job.LoadSnowflakeTable.DataLoadingFailed';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.LoadSnowflakeTable.DatabaseNotExistsOrNotAuthorized';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_FILE_FORMAT_CHANGED =
    'europa.job.LoadSnowflakeTable.FileFormatChanged';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.job.LoadSnowflakeTable.InsufficientPrivileges';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.job.LoadSnowflakeTable.InsufficientTaskPrivileges';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.job.LoadSnowflakeTable.InvalidAccessToken';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.job.LoadSnowflakeTable.InvalidAccountName';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_INVALID_IDENTIFIER =
    'europa.job.LoadSnowflakeTable.InvalidIdentifier';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.job.LoadSnowflakeTable.InvalidParameterTypeForFunction';
export const LOAD_SNOWFLAKE_TABLE_SUCCESS_LOAD_SNOWFLAKE_TABLE_RESULT =
    'europa.job.LoadSnowflakeTable.LoadSnowflakeTableResult';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.job.LoadSnowflakeTable.MaxFileSizeExceeded';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_MISSING_COLUMN =
    'europa.job.LoadSnowflakeTable.MissingColumn';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.job.LoadSnowflakeTable.NoActiveWarehouseSelected';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.job.LoadSnowflakeTable.NotAuthenticatedToSnowflake';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.LoadSnowflakeTable.NotExistsOrNotAuthorized';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.job.LoadSnowflakeTable.NotExistsOrOperationCannotBePerformed';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.job.LoadSnowflakeTable.ObjectAlreadyExists';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.job.LoadSnowflakeTable.SchemaNotExistsOrNotAuthorized';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.job.LoadSnowflakeTable.SnowflakeInternalServerError';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.job.LoadSnowflakeTable.SnowflakeNotConfigured';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.job.LoadSnowflakeTable.SnowflakeQueryCanceled';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_TARGET_TABLE_NOT_EXISTS =
    'europa.job.LoadSnowflakeTable.TargetTableNotExists';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_TIMEOUT = 'europa.job.LoadSnowflakeTable.Timeout';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.job.LoadSnowflakeTable.UncategorizedSqlError';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.LoadSnowflakeTable.UnexpectedFailure';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_UNKNOWN_FUNCTION =
    'europa.job.LoadSnowflakeTable.UnknownFunction';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.job.LoadSnowflakeTable.UnknownFunctions';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.job.LoadSnowflakeTable.UserDiffersFromToken';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.job.LoadSnowflakeTable.ValueNotRecognized';
export const LOAD_SNOWFLAKE_TABLE_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.job.LoadSnowflakeTable.WarehouseSuspended';
export const UNLOAD_SNOWFLAKE_TABLE_FAILURE_CANCELED = 'europa.job.UnloadSnowflakeTable.Canceled';
export const UNLOAD_SNOWFLAKE_TABLE_FAILURE_NO_DEPLOYMENT_HISTORY =
    'europa.job.UnloadSnowflakeTable.NoDeploymentHistory';
export const UNLOAD_SNOWFLAKE_TABLE_FAILURE_TIMEOUT = 'europa.job.UnloadSnowflakeTable.Timeout';
export const UNLOAD_SNOWFLAKE_TABLE_FAILURE_UNEXPECTED_FAILURE =
    'europa.job.UnloadSnowflakeTable.UnexpectedFailure';
export const UNLOAD_SNOWFLAKE_TABLE_SUCCESS_UNLOAD_JOB_RUN_RESULT =
    'europa.job.UnloadSnowflakeTable.UnloadJobRunResult';
